import { render, staticRenderFns } from "./InvestmentsModals.vue?vue&type=template&id=341fce3c&scoped=true&"
import script from "./InvestmentsModals.vue?vue&type=script&lang=js&"
export * from "./InvestmentsModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341fce3c",
  null
  
)

export default component.exports